import { render, staticRenderFns } from "./ConfirmacaoEmail.vue?vue&type=template&id=6e49cfb4"
import script from "./ConfirmacaoEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports